export const mgPlatformLineChartIcon = {
  data: `<svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1V15.5H15.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 13L7.15385 9L9.92308 11.5L15 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>`,
  name: 'line-chart'
}
